import RANGE_TYPES from "./rangeTypes";
const oneHour = 60 * 60 * 1000;
export default {
    LAST_HOUR(ms) {
        const now = ms ? new Date(ms) : new Date();
        return {
            type: RANGE_TYPES.LAST_HOUR,
            startDateTime: now.getTime() - oneHour,
            endDateTime: now.getTime()
        };
    },
    TODAY(ms) {
        const now = ms ? new Date(ms) : new Date();
        return {
            type: RANGE_TYPES.TODAY,
            startDateTime: now.setHours(0, 0, 0, 0),
            endDateTime: now.setHours(23, 59, 59, 999)
        };
    },
    YESTERDAY(ms) {
        const yesterday = new Date((ms || new Date().getTime()) - 24 * oneHour);
        return {
            type: RANGE_TYPES.YESTERDAY,
            startDateTime: yesterday.setHours(0, 0, 0, 0),
            endDateTime: yesterday.setHours(23, 59, 59, 999)
        };
    },
    LAST_7_DAYS(ms) {
        const now = ms ? new Date(ms) : new Date();
        return {
            type: RANGE_TYPES.LAST_7_DAYS,
            startDateTime: new Date(now.getTime() - 7 * 24 * oneHour).setHours(0, 0, 0, 0),
            endDateTime: now.setHours(23, 59, 59, 999)
        };
    },
    LAST_30_DAYS(ms) {
        const now = ms ? new Date(ms) : new Date();
        return {
            type: RANGE_TYPES.LAST_30_DAYS,
            startDateTime: new Date(now.getTime() - 30 * 24 * oneHour).setHours(0, 0, 0, 0),
            endDateTime: now.setHours(23, 59, 59, 999)
        };
    },
    ALL_TIME(ms) {
        const now = ms ? new Date(ms) : new Date();
        return {
            type: RANGE_TYPES.ALL_TIME,
            startDateTime: new Date("2000-01-01").getTime(),
            endDateTime: now.setHours(23, 59, 59, 999)
        };
    }
};
